export default [
	{  // 订单列表
		path: 'order_list',
		name: 'm_order_sell',
		props: route => route.query,
		component: () => import('@/pages/order/order_list')
	}, {  // 订单详情
		path: 'order_detail/:orderNumber',
		name: 'order_detail',
		meta: {
			title: '订单详情'
		},
		props: route => route.params,
		component: () => import('@/pages/order/order_detail')
	}, {  // 购买代理订单列表
		path: 'membership_record_list',
		name: 'm_membership_record',
		props: route => route.query,
		component: () => import('@/pages/order/membership_upgrade_record_list')
	}, {  // 购买代理订单详情
		path: 'membership_record/:id',
		name: 'm_membership_record_detail',
		meta: {
			title: '购买代理订单详情'
		},
		props: route => route.params,
		component: () => import('@/pages/order/membership_upgrade_record_detail')
	}, {  // 余额充值订单列表
		path: 'recharge_record_list',
		name: 'm_recharge_record',
		props: route => route.query,
		component: () => import('@/pages/order/recharge_record_list')
	}, {  // 余额充值订单详情
		path: 'recharge_record/:id',
		name: 'm_recharge_record_detail',
		meta: {
			title: '余额充值订单详情'
		},
		props: route => route.params,
		component: () => import('@/pages/order/recharge_record_detail')
	}, {  // 零售订单列表
		path: 'retail/order/list',
		name: 'm_retail_order',
		props: route => route.query,
		component: () => import('@/pages/order/retail_order_list')
	}, {  // 零售订单明细
		path: 'retail_order/:orderNumber',
		name: 'retail_order_detail',
		meta: {
			title: '订单详情'
		},
		props: route => route.params,
		component: () => import('@/pages/order/retail_order_detail')
	}, {  // 转账支付订单列表
		path: 'cash/order/list',
		name: 'm_cash_order',
		props: route => route.query,
		component: () => import('@/pages/order/cash_order_list')
	}, {  // 转账支付订单详情
		path: 'cash_order/:orderNumber',
		name: 'cash_order_detail',
		meta: {
			title: '转账支付订单详情'
		},
		props: route => route.params,
		component: () => import('@/pages/order/cash_order_detail')
	}, {  // 订单售后
		path: 'after_sales_apply',
		name: 'after_sales_apply',
		meta: {
			title: '申请售后'
		},
		props: route => route.query,
		component: () => import('@/pages/order/after_sales_apply')
	}, {  // 退款单列表
		path: 'refund_list',
		name: 'm_order_refund',
		props: route => route.query,
		component: () => import('@/pages/order/refund_list')
	}, {  // 退款单详情
		path: 'refund_detail/:refundNumber',
		name: 'refund_detail',
		meta: {
			title: '退款详情'
		},
		props: route => Object.assign(route.query, route.params),
		component: () => import('@/pages/order/refund_detail')
	}, {  // 售后单列表
		path: 'return_list',
		name: 'm_order_return',
		props: route => route.query,
		component: () => import('@/pages/order/return_list')
	}, {  // 售后单详情
		path: 'return_detail/:returnNumber',
		name: 'return_detail',
		meta: {
			title: '售后详情'
		},
		props: route => route.params,
		component: () => import('@/pages/order/return_detail')
	},{  // 订单商品评价列表
		path: 'order_evaluate_list',
		name: 'm_order_evaluate',
		component: () => import('@/pages/order/order_evaluate_list')
	}, {  // 订单商品评价详情
		path: 'order_evaluate_detail/:id',
		name: 'order_evaluate_detail',
		meta: {
			title: '订单商品评价详情'
		},
		props: route => route.params,
		component: () => import('@/pages/order/order_evaluate_detail')
	},{  // 采购订单列表
		path: 'purchase_order',
		name: 'm_purchase_order',
		component: () => import('@/pages/order/purchase_order_list')
	}, {  // 采购单详情
		path: 'purchase_order_detail/:orderNumber',
		name: 'b_purchase_order_view',
		meta: {
			title: '采购单详情'
		},
		props: route => route.params,
		component: () => import('@/pages/order/purchase_order_detail')
	}, {  // 代客开单
		path: 'agency_order',
		name: 'm_agency_order',
		component: () => import('@/pages/order/agency_order')
	}, {  //虚拟商品卡券核销
		path: 'service_card_detail',
		name: 'm_service_card',
		component: () => import('@/pages/order/service_card_detail')
	}, {  //虚拟商品卡券核销记录
		path: 'service_card_record',
		name: 'm_service_card_record',
		component: () => import('@/pages/order/service_card_record')
	}, {  // 子订单列表
		path: 'sub_order_list',
		name: 'm_sub_order',
		props: route => route.query,
		component: () => import('@/pages/order/sub_order_list')
	}, {  // 零售订单明细
		path: 'sub_order/:orderNumber',
		name: 'sub_order_detail',
		meta: {
			title: '销售订单明细详情'
		},
		props: route => route.params,
		component: () => import('@/pages/order/sub_order_detail')
	}, {  // 平台纠纷
		path: 'dispute_list',
		name: 'm_dispute',
		props: route => route.query,
		component: () => import('@/pages/order/dispute_list')
	}, {  // 纠纷详情
		path: 'dispute_detail/:id',
		name: 'dispute_detail',
		meta: {
			title: '纠纷详情'
		},
		props: route => Object.assign(route.query, route.params),
		component: () => import('@/pages/order/dispute_detail')
	},

];